export const CouponActionTypes = {
  GET: {
    GET_COUPON_PENDING: "GET_COUPON_PENDING",
    GET_COUPON_SUCCESS: "GET_COUPON_SUCCESS",
    GET_COUPON_ERROR: "GET_COUPON_ERROR",
  },

  CHECK_COUPON_PENDING: "CHECK_COUPON_PENDING",
  CHECK_COUPON_SUCCESS: "CHECK_COUPON_SUCCESS",
  CHECK_COUPON_ERROR: "CHECK_COUPON_ERROR",

  CANCEL_COUPON_PENDING: "CANCEL_COUPON_PENDING",
  CANCEL_COUPON_SUCCESS: "CANCEL_COUPON_SUCCESS",
  CANCEL_COUPON_ERROR: "CANCEL_COUPON_ERROR",
};
